import React from 'react';
import PropTypes from 'prop-types';

import { texts } from 'utils/languages/fr';
import { CustomFormLabel } from 'components';
import { FormControl, Select, FormHelperText, MenuItem } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import * as icons from 'mdi-material-ui';

const useStyles = makeStyles(theme => ({
    paper: {
        padding: 0,
    },
    listRoot: {
        maxHeight: 228,
        overflowY: 'auto',
    },
    icon: {
        fontSize: 28,
        color: theme.palette.grey[600],
    },
}));

const CustomSelect = props => {
    const {
        children,
        error,
        label,
        fullWidth,
        inputStyle,
        labelId,
        helperText,
        controlSx,
        ...rest
    } = props;
    const classes = useStyles();

    return (
        <FormControl
            sx={controlSx}
            error={!!error}
            fullWidth={fullWidth}
            classes={{ root: inputStyle }}
        >
            {label && <CustomFormLabel id={labelId}>{label}</CustomFormLabel>}
            <Select
                variant="outlined"
                {...rest}
                fullWidth={fullWidth}
                IconComponent={icons.ChevronDown}
                classes={{ icon: classes.icon, ...rest.classes }}
                MenuProps={{
                    classes: { paper: classes.paper },
                    PaperProps: { square: true },
                    elevation: 1,
                    MenuListProps: {
                        disablePadding: true,
                        dense: true,
                        classes: { root: classes.listRoot },
                    },
                }}
            >
                {!children.length && (
                    <MenuItem value={0} disabled>
                        {texts.NO_OPTIONS}
                    </MenuItem>
                )}
                {children}
            </Select>
            {!!error && helperText && <FormHelperText error={!!error}>{helperText}</FormHelperText>}
        </FormControl>
    );
};

CustomSelect.propTypes = {
    children: PropTypes.node,
    error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    inputStyle: PropTypes.string,
    labelId: PropTypes.string,
    label: PropTypes.string,
    helperText: PropTypes.string,
    fullWidth: PropTypes.bool,
    controlSx: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
};

export default CustomSelect;
